





































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Company } from '../store/company'
import { MachineDetail, AddMachine } from '../store/machine'
import { Sensor, SensorType } from '../store/sensor'
import { Alarm } from '../store/alarm'
import Select from './Select.vue'
import { Warning } from '../store/warning'
@Component({ components: { Select } })
export default class MachineForm extends Vue {
  @Prop() title!: string
  @Prop() sensors!: Sensor[]
  @Prop() alarms!: Alarm[]
  @Prop() warnings!: Warning[]

  @Prop() companies!: Company[]
  @Prop({ default: () => ({}) }) placeholder!: MachineDetail
  @Prop({ default: () => true }) editId!: boolean

  id = this.placeholder.id || ''
  companyId: number | null = this.placeholder?.company?.id ?? null
  sensorSearch = ''
  location = this.placeholder.location || ''
  analogSensorsSelected: Sensor[] = this.getInitialAnalogSensors()
  digitalSensorsSelected: Sensor[] = this.getInitialDigitalSensors()
  alarmsSelected: Alarm[] = this.getInitialAlarms()
  warningsSelected: Warning[] = this.getInitialWarnings()
  idRules = [(v: string) => !!v || 'ID is required']
  companyIdRules = [(v: string) => !!v || 'Company is required']
  locationRules = [(v: string) => !!v || 'Location is required']

  valid = false

  get companyOptions() {
    return this.companies.map(({ id, name }) => ({ text: name, value: id }))
  }
  get digitalSensors() {
    return this.sensors.filter(sensor => sensor.type === SensorType.DIGITAL)
  }
  get analogSensors() {
    return this.sensors.filter(sensor => sensor.type === SensorType.ANALOG)
  }

  getInitialAlarms() {
    return this.placeholder?.alarms ?? []
  }
  getInitialWarnings() {
    return this.placeholder?.warnings ?? []
  }
  getInitialSensors() {
    return this.placeholder?.sensors ?? []
  }
  getInitialDigitalSensors() {
    return this.getInitialSensors().filter(
      sensor => sensor.type === SensorType.DIGITAL
    )
  }
  getInitialAnalogSensors() {
    return this.getInitialSensors().filter(
      sensor => sensor.type === SensorType.ANALOG
    )
  }

  @Watch('placeholder')
  reset() {
    this.digitalSensorsSelected = this.getInitialDigitalSensors()
    this.analogSensorsSelected = this.getInitialAnalogSensors()
    this.alarmsSelected = this.getInitialAlarms()
    this.warningsSelected = this.getInitialWarnings()
    this.id = this.placeholder.id ?? ''
    this.companyId = this.placeholder?.company?.id ?? null
    this.sensorSearch = ''
    this.location = this.placeholder.location ?? ''
  }

  submit() {
    const id = this.id
    const oldId = this.placeholder.id || ''
    const location = this.location
    const companyId = this.companyId as number
    const digitalSensors = this.digitalSensorsSelected.map(s => s.id)
    const analogSensors = this.analogSensorsSelected.map(s => s.id)
    const sensors = digitalSensors.concat(analogSensors)
    const alarms = this.alarmsSelected.map(a => a.id)
    const warnings = this.warningsSelected.map(a => a.id)

    const machine: AddMachine = {
      id,
      oldId,
      companyId,
      location,
      sensors,
      alarms,
      warnings
    }
    this.reset()
    this.$emit('submit', machine)
  }

  cancel() {
    this.reset()
    this.$emit('cancel')
  }
}
